import { useEffect, useState, useRef } from "react";
import {
  Container,
  Heading,
  HeadingWrapper,
  InfoDiv,
  InfoLink,
  MentorCardWrapper,
  StudentFormWrapper,
  SubHeading,
  SubHeadingWrapper,
} from "./Elements";
import Form from "./Form";
import MentorCard from "./MentorCard";
import { mentorQuery, submitStudentQuery } from "./queries";
import "./font.css";

const Widget = ({
  university = "telaviv",
  header = "Tel Aviv",
  fontFamily = "Outfit",
  headerColor = "black",
}) => {
  const [mentors, setMentors] = useState([]);
  const [selectedMentor, setSelectedMentor] = useState(null);
  const formRef = useRef();

  useEffect(() => {
    async function runQuery() {
      const result = await mentorQuery();
      const mentorData = result.data;
      mentorData.sort((a, b) => a.name.localeCompare(b.name));
      const filteredMentors = mentorData.filter(
        (x) => x.university_mentor === university
      );
      setMentors(filteredMentors);
    }
    runQuery();
  }, [university]);

  const updateMentorSelection = (mentor) => {
    setSelectedMentor(mentor);
  };

  const isMobile = {
    Android: function () {
      return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
      return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
      return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
      return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
      return (
        navigator.userAgent.match(/IEMobile/i) ||
        navigator.userAgent.match(/WPDesktop/i)
      );
    },
    any: function () {
      return (
        isMobile.Android() ||
        isMobile.BlackBerry() ||
        isMobile.iOS() ||
        isMobile.Opera() ||
        isMobile.Windows()
      );
    },
  };

  const handleFormSubmit = async (form) => {
    if (!selectedMentor?.name) setSelectedMentor(null);

    if (selectedMentor === null) {
      console.log("select a mentor first");
      return;
    }

    await submitStudentQuery(form);

    console.log("inside form submit");
    if (selectedMentor.name) {
      console.log("isMobile", isMobile.any());
      if (isMobile.any()) {
        window.open(
          `whatsapp://send?phone=${selectedMentor.phone}&text=Hi%20${
            selectedMentor.name.split(" ")[0]
          }%21`,
          "_blank"
        );
      } else {
        window.open(
          `https://web.whatsapp.com/send?phone=${
            selectedMentor.phone
          }&text=Hi%20${selectedMentor.name.split(" ")[0]}%21`
        );
      }
    }
  };

  const handleWhatsappButtonClick = async (mentor) => {
    updateMentorSelection(mentor);
    console.dir(formRef.current.click());
  };

  return (
    <Container>
      <HeadingWrapper headerColor={headerColor}>
        <Heading fontFamily={fontFamily}>
          Speak to {header} students <br /> on WhatsApp
        </Heading>
      </HeadingWrapper>
      <SubHeadingWrapper>
        <SubHeading
          fontFamily={fontFamily}
          fontSize={fontFamily === "metric" ? "1.1rem" : "0.8rem"}
        >
          Get an insider's perspective on your LLM application
        </SubHeading>
      </SubHeadingWrapper>
      <MentorCardWrapper style={{ overflow: "auto" }}>
        {mentors.map((mentor) => (
          <MentorCard
            key={mentor._id}
            mentor={mentor}
            selected={mentor._id === selectedMentor?._id}
            fontFamily={fontFamily}
            onCardClick={() => updateMentorSelection(mentor)}
            onWhatsappButtonClick={handleWhatsappButtonClick}
          />
        ))}
        <InfoDiv fontFamily={fontFamily}>
          Powered by
          <InfoLink
            fontFamily={fontFamily}
            target={"_blank"}
            noreferrer
            href="https://collegeit.org"
          >
            CollegeIt
          </InfoLink>
        </InfoDiv>
      </MentorCardWrapper>
      <StudentFormWrapper>
        <Form
          formRef={formRef}
          onFormSubmit={handleFormSubmit}
          mentor={selectedMentor}
          fontFamily={fontFamily}
        />
      </StudentFormWrapper>
    </Container>
  );
};

export default Widget;
